import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

const api = axios.create({
  baseURL: API_URL + "/api",
  withCredentials: true,
});

let isRefreshing = false;

function isAuthRoute(url = "") {
  return (
    url.includes("/auth/login") ||
    url.includes("/auth/refresh") ||
    url.includes("/auth/logout")
  );
}

function isResetValidateRoute(url = "") {
  return url.includes("/auth/reset/validate");
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error;

    if (!response || !config) throw error;
    if (response.status !== 401) throw error;

    if (config._retry) throw error;
    config._retry = true;

    if (isAuthRoute(config.url || "")) throw error;
    if (isResetValidateRoute(config.url || "")) throw error;

    if (isRefreshing) throw error;

    isRefreshing = true;
    try {
      await api.post("/auth/refresh", null);
      return api(config);
    } catch (e) {
      window.dispatchEvent(new Event("mm:auth:logout"));
      throw error;
    } finally {
      isRefreshing = false;
    }
  },
);

export default api;
